import styled from "styled-components";

export const ProgressBarWrapper = styled.div`
    ${'' /* display: ${(props) => props?.showProgress ? 'flex' : 'None' || 'None'}; */}
    ${'' /* width: ${(props) => props.width ? props.width : "100%"}; */}
    ${'' /* position: relative; */}
    ${'' /* transform: translateX(-50%); */}
    ${'' /* left: 50%; */}
    ${'' /* margin: 1em 0 0 0; */}
    ${'' /* background-color: red; */}
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: ${(props) => props?.showProgress ? '3px solid #c7222a' : 'None' || 'None'};
    min-height: 65px;
    .progressBar {
        display: ${(props) => props?.showProgress ? 'flex' : 'None' || 'None'};
        justify-content: space-evenly;
        ${'' /* gap: 10px; */}
        width: 100%;
        ${'' /* background-color: whitesmoke; */}
        ${'' /* height: 0.3em; */}
    }
`;
